import { BaseEvent } from "@/api/ws/events/BaseEvent";

export default class AiAgentResponseReceivedEvent extends BaseEvent<{ message: string }> {
  name = ".ai_agent_session_response_received";
}
